// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".artist-box{display:inline-block;border:1px solid #c3c4be;border-radius:3px;width:100%;height:100%;padding:10px}", ""]);
// Exports
module.exports = exports;
